const Service_cards = [
  {
    id: Math.random(),
    name: "Web Design",
    desc: "Crafting visually stunning designs that will leave you speechless",
  },
  {
    id: Math.random(),
    name: "Marketing",
    desc: "Crafting visually stunning designs that will leave you speechless",
  },
  {
    id: Math.random(),
    name: "Branding",
    desc: "We'll advertise your product using latest and unique fresh marketing methods.",
  },
  {
    id: Math.random(),
    name: "Pricing",
    desc: "We'll advertise your product using latest and unique fresh marketing methods.",
  },
  {
    id: Math.random(),
    name: "Team",
    desc: "We'll advertise your product using latest and unique fresh marketing methods.",
  },
  {
    id: Math.random(),
    name: "Contact",
    desc: "We'll advertise your product using latest and unique fresh marketing methods.",
  },
  {
    id: Math.random(),
    name: "Web Design",
    desc: "We'll advertise your product using latest and unique fresh marketing methods.",
  },
  {
    id: Math.random(),
    name: "Marketing",
    desc: "We'll advertise your product using latest and unique fresh marketing methods.",
  },
];

export default Service_cards;
